import ListRfqsAsList from '../../../../../../client/src/rfq/src/viewmodel/ListRfqsAsListViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesListRfqsAsList extends DesBaseCollabAcc {

    constructor() {
        console.log('DesListRfqsAsList invoked');
        super(ListRfqsAsList);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id' ];
    }
}
if (!window.customElements.get('des-list-rfqs-as-list')) {
    window.customElements.define('des-list-rfqs-as-list', DesListRfqsAsList);
}
